// extracted by mini-css-extract-plugin
export var box = "_55-0";
export var check = "_55-1";
export var checkboxButton = "_55-6";
export var checkboxGroup = "_55-5";
export var disabled = "_55-7";
export var ghost = "_55-9";
export var input = "_55-2";
export var label = "_55-4";
export var normal = "_55-8";
export var uncheck = "_55-3";